module.exports = __webpack_public_path__ + "static/media/le_catalogue_de_formation_safe_technologies_v2.2.dac67c6b.pdf";